import { render, staticRenderFns } from "./jdbk.vue?vue&type=template&id=35955c76&scoped=true"
import script from "./jdbk.vue?vue&type=script&lang=js"
export * from "./jdbk.vue?vue&type=script&lang=js"
import style0 from "./jdbk.vue?vue&type=style&index=0&id=35955c76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35955c76",
  null
  
)

export default component.exports